package org.multiplatform.kotfolio.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.runtime.snapshotFlow
import org.multiplatform.kotfolio.models.Section
import org.multiplatform.kotfolio.models.Theme
import org.multiplatform.kotfolio.util.Constants
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.forms.TextInput
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.animation.Keyframes
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import kotlinx.browser.document
import kotlinx.collections.immutable.ImmutableMap
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.FlowPreview
import kotlinx.coroutines.delay
import kotlinx.coroutines.flow.debounce
import kotlinx.coroutines.flow.distinctUntilChanged
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.ExperimentalComposeWebApi
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.koin.mp.KoinPlatform.getKoin
import org.multiplatform.kotfolio.components.AppearanceAwareImage
import org.multiplatform.kotfolio.di.BlogController
import org.multiplatform.kotfolio.domain.Blog
import org.multiplatform.kotfolio.feature.BlogDiscoveryUIModel
import org.multiplatform.kotfolio.styles.InputStyle
import org.multiplatform.kotfolio.util.PortfolioData
import org.multiplatform.kotfolio.util.Resources
import org.multiplatform.kotfolio.util.Resources.Images.SEARCH_LIGHT
import kotlin.collections.isNotEmpty
import kotlin.time.Duration.Companion.milliseconds

private val AMBER_500 = Color.rgb(245, 158, 11)
private val DARK_CARD_BG = Color.rgb(22, 18, 15) // Darker brown/black for cards
private val CARD_BORDER = Color.rgba(245, 158, 11, 0.1f)

@OptIn(DelicateApi::class, FlowPreview::class)
@Composable
fun BlogSection(
    viewModel: BlogController = getKoin().get(),
    blogDiscoveryUIModel: BlogDiscoveryUIModel = getKoin().get())
{
    val breakpoint = rememberBreakpoint()
    val isDesktop = breakpoint >= Breakpoint.MD
    val scope = rememberCoroutineScope()

    //val state by blogDiscoveryUIModel.uiState.collectAsState()

    val selectBlog = remember { mutableStateOf("Flutter") }

    val allBlogs by viewModel.blogs.collectAsState()
    val isSearchExpanded = remember { mutableStateOf(false) }
    var searchText by remember { mutableStateOf("") }

    //https://www.linkedin.com/in/mdtayoburrahman
    LaunchedEffect (Unit) {
        snapshotFlow { searchText }
            .debounce(300.milliseconds)
            .distinctUntilChanged()
            .collect { search ->
                viewModel.filterBlogsByDescription(search)
            }
    }

    LaunchedEffect(Unit) {
        val style = document.createElement("style")
        style.textContent = """
            @keyframes adminRowIn {
                from { opacity: 0; transform: translateX(-6px); }
                to   { opacity: 1; transform: translateX(0); }
            }
        """.trimIndent()
        document.head?.appendChild(style)
    }

    Column(
        modifier = Modifier
            .id(Section.Blog.id)
            .fillMaxWidth()
            .padding(topBottom = if (isDesktop) 150.px else 80.px)
            .backgroundColor(Theme.Background.rgb)
            .styleModifier {
                // Subtle geometric pattern
                property(
                    "background-image",
                    "radial-gradient(circle at 2px 2px, rgba(255,255,255,0.01) 1px, transparent 0)",
                )
                property("background-size", "50px 50px")
            },
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        // Header
        Column(
            modifier = Modifier.margin(bottom = 100.px),
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            Span(
                attrs = Modifier
                    .fontFamily(Constants.FONT_FAMILY)
                    .fontSize(16.px)
                    .fontWeight(FontWeight.Bold)
                    .color(AMBER_500)
                    .margin(bottom = 12.px)
                    .styleModifier {
                        property("letter-spacing", "6px")
                        property("text-transform", "uppercase")
                    }
                    .toAttrs(),
            ) {
                Text("Comprehension")
            }

            P(
                attrs = Modifier
                    .fontFamily(Constants.FONT_FAMILY)
                    .fontSize(if (isDesktop) 54.px else 36.px)
                    .fontWeight(FontWeight.Black)
                    .color(Colors.White)
                    .margin(topBottom = 0.px)
                    .textAlign(TextAlign.Center)
                    .toAttrs(),
            ) {
                Text("Blog")
            }

            Box(
                modifier = Modifier
                    .margin(top = 16.px)
                    .width(80.px)
                    .height(3.px)
                    .backgroundColor(AMBER_500)
                    .borderRadius(2.px)
            )
        }

        if (viewModel.getBlogCountMap.isNotEmpty()) {
            Row(
                modifier = Modifier.fillMaxWidth().maxWidth(Constants.SECTION_WIDTH.px)
                    .padding(leftRight = if (isDesktop) 2.percent else 5.percent).styleModifier { property("flex-wrap", "wrap") },
                horizontalArrangement = Arrangement.Start,
            ) {
                viewModel.getBlogCountMap.forEach { tag ->
                    Button(
                        modifier = Modifier
                            .backgroundColor(Color.rgba(245, 158, 11, 0.05f))
                            .margin(right = 8.px, bottom = 8.px)
                            .padding(leftRight = 15.px, topBottom = 0.px)
                            .borderRadius(15.px)
                            .border(1.px, LineStyle.Solid, Color.rgba(245, 158, 11, 0.15f)),
                        onClick = { _ ->
                            scope.launch {
                                searchText = ""
                                selectBlog.value = tag.key
                                viewModel.filter(selectBlog.value)
                            }
                        }) {
                        Span(
                            attrs = Modifier
                                .fontSize(14.px)
                                .color(AMBER_500)
                                .toAttrs()
                        ) {
                            Text("${tag.key} (${tag.value})")
                        }
                    }
                }

                SearchBar(
                    modifier = Modifier.fillMaxWidth(),
                    scope = scope,
                    isSearchExpanded = isSearchExpanded.value,
                    searchText = searchText,
                    onSearchTextChange = {
                        searchText = it
                    },
                    onSearchExpanded = { isSearchExpanded.value = !isSearchExpanded.value}
                )
            }
        }

        Box(
            modifier = Modifier
                .fillMaxWidth()
                .maxWidth(Constants.SECTION_WIDTH.px)
                .padding(leftRight = if (isDesktop) 2.percent else 5.percent),
            contentAlignment = Alignment.TopCenter
        ) {
            Column(modifier = Modifier.fillMaxWidth()) {
                allBlogs.blogs.BlogItem()
            }
        }

        /*
        if (state.languages.isNotEmpty()) {
            Row(
                modifier = Modifier.fillMaxWidth().maxWidth(Constants.SECTION_WIDTH.px)
                    .padding(leftRight = if (isDesktop) 2.percent else 5.percent).styleModifier { property("flex-wrap", "wrap") },
                horizontalArrangement = Arrangement.Start,
            ) {
                state.languages.forEach { tag ->
                    Button(
                        modifier = Modifier
                            .backgroundColor(Color.rgba(245, 158, 11, 0.05f))
                            .margin(right = 8.px, bottom = 8.px)
                            .padding(leftRight = 15.px, topBottom = 1.px)
                            .borderRadius(15.px)
                            .border(1.px, LineStyle.Solid, Color.rgba(245, 158, 11, 0.15f)),
                        onClick = { _ ->
                            scope.launch {
                                blogDiscoveryUIModel.sendCommand(BlogDiscoveryCommand.SelectLanguage(tag))
                            }
                        }) {
                        Span(
                            attrs = Modifier
                                .fontSize(14.px)
                                .color(AMBER_500)
                                .toAttrs()
                        ) {
                            Text(tag.name)
                        }
                    }
                }
            }
        }

        if (state.topics.isNotEmpty()) {
            Row(
                modifier = Modifier.fillMaxWidth().maxWidth(Constants.SECTION_WIDTH.px)
                    .padding(leftRight = if (isDesktop) 2.percent else 5.percent).styleModifier { property("flex-wrap", "wrap") },
                horizontalArrangement = Arrangement.Start,
            ) {
                state.topics.forEach { tag ->
                    Button(
                        modifier = Modifier
                            .backgroundColor(Color.rgba(245, 158, 11, 0.05f))
                            .margin(right = 8.px, bottom = 8.px)
                            .padding(leftRight = 15.px, topBottom = 1.px)
                            .borderRadius(15.px)
                            .border(1.px, LineStyle.Solid, Color.rgba(245, 158, 11, 0.15f)),
                        onClick = { _ ->
                            scope.launch {
                                blogDiscoveryUIModel.sendCommand(BlogDiscoveryCommand.SelectTopic(tag))
                            }
                        }) {
                        Span(
                            attrs = Modifier
                                .fontSize(14.px)
                                .color(AMBER_500)
                                .toAttrs()
                        ) {
                            Text(tag.name)
                        }
                    }
                }
            }
        }

        Box(
            modifier = Modifier
                .fillMaxWidth()
                .maxWidth(Constants.SECTION_WIDTH.px)
                .padding(leftRight = if (isDesktop) 2.percent else 5.percent),
            contentAlignment = Alignment.TopCenter
        ) {
            Column(modifier = Modifier.fillMaxWidth()) {
                repeat(state.tracks.size) {
                    BlogVertical(state.tracks[it])
                }
            }
        }*/
    }
}

@Composable
private fun BlogVertical(blog: Blog) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .margin(topBottom = 10.px),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        BlogItem(blog)
    }
}

@Composable
private fun BlogItem(blog: Blog) {
    (val _ = index, val _ = totalView, val links, val blogEnum = blogEnum) = blog

    links.forEach { [text, url] ->
        Link(
            path = url,
            //openExternalLinksStrategy = OpenLinkStrategy.IN_NEW_TAB,
            modifier = Modifier.fillMaxWidth()
                .styleModifier {
                    property("text-decoration", "none")
                    property("transition", "all 0.3s ease")
                },
        ) {
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .backgroundColor(DARK_CARD_BG)
                    .borderRadius(20.px)
                    .border(1.px, LineStyle.Solid, CARD_BORDER)
                    .styleModifier {
                        property("box-shadow", "0 10px 40px rgba(0,0,0,0.2)")
                        property("position", "relative")
                    },
            ) {
                Box(
                    modifier = Modifier
                        .position(Position.Absolute)
                        .top(0.px)
                        .right(0.px)
                        .backgroundColor(AMBER_500)
                        .padding(leftRight = 14.px, topBottom = 0.px)
                        .borderRadius(bottomLeft = 12.px, topRight = 20.px),
                ) {
                    Span(
                        attrs = Modifier
                            .fontFamily(Constants.FONT_FAMILY)
                            .fontSize(11.px)
                            .color(Colors.White)
                            .styleModifier {
                                property("letter-spacing", "1px")
                                property("text-transform", "uppercase")
                            }
                            .toAttrs()
                    ) {
                        Text(blogEnum.fromTo)
                    }
                }

                Column(modifier = Modifier.padding(all = 32.px)) {
                    P(
                        attrs = Modifier
                            .fontFamily(Constants.FONT_FAMILY)
                            .fontSize(26.px)
                            .fontWeight(FontWeight.Black)
                            .color(Colors.White)
                            .margin(topBottom = 0.px)
                            .toAttrs(),
                    ) {
                        Text(text)
                    }

                    Row(
                        modifier = Modifier
                            .margin(top = 16.px, bottom = 24.px)
                            .backgroundColor(Color.rgba(255, 255, 255, 0.03f))
                            .padding(leftRight = 14.px, topBottom = 8.px)
                            .borderRadius(8.px),
                        verticalAlignment = Alignment.CenterVertically,
                    ) {
                        Span(
                            attrs = Modifier
                                .fontFamily(Constants.FONT_FAMILY)
                                .fontSize(16.px)
                                .color(Color.rgba(255, 255, 255, 0.7f))
                                .toAttrs(),
                        ) {
                            Text(blogEnum.description)
                        }
                    }

                    // Bullet Points
                    if (blogEnum.bulletPoints.isNotEmpty()) {
                        Column(modifier = Modifier.margin(bottom = 32.px)) {
                            blogEnum.bulletPoints.forEach { point ->
                                Row(modifier = Modifier.margin(bottom = 12.px)) {
                                    Box(
                                        modifier = Modifier
                                            .size(6.px)
                                            .backgroundColor(AMBER_500)
                                            .margin(top = 8.px, right = 14.px)
                                            .borderRadius(50.percent),
                                    )
                                    P(
                                        attrs = Modifier
                                            .margin(topBottom = 0.px)
                                            .fontFamily(Constants.FONT_FAMILY)
                                            .fontSize(14.px)
                                            .color(Color.rgba(255, 255, 255, 0.5f))
                                            .lineHeight(1.6)
                                            .toAttrs(),
                                    ) {
                                        Text(point.replace("▪ ", "").trim())
                                    }
                                }
                            }
                        }
                    }

                    if (blogEnum.tags.isNotEmpty()) {
                        Row(
                            modifier = Modifier.fillMaxWidth()
                                .styleModifier { property("flex-wrap", "wrap") },
                            horizontalArrangement = Arrangement.Start,
                        ) {
                            blogEnum.tags.forEach { tag ->
                                Box(
                                    modifier = Modifier
                                        .margin(right = 8.px, bottom = 8.px)
                                        .backgroundColor(Color.rgba(245, 158, 11, 0.05f))
                                        .padding(leftRight = 10.px, topBottom = 5.px)
                                        .borderRadius(6.px)
                                        .border(
                                            1.px,
                                            LineStyle.Solid,
                                            Color.rgba(245, 158, 11, 0.15f)
                                        ),
                                ) {
                                    Span(
                                        attrs = Modifier
                                            .fontFamily(Constants.FONT_FAMILY)
                                            .fontSize(10.px)
                                            .fontWeight(FontWeight.Bold)
                                            .color(AMBER_500)
                                            .toAttrs(),
                                    ) {
                                        Text(tag)
                                    }
                                }
                            }
                        }
                    }

                    if (blogEnum.linkTags.isNotEmpty()) {
                        Row(
                            modifier = Modifier.fillMaxWidth()
                                .styleModifier { property("flex-wrap", "wrap") },
                            horizontalArrangement = Arrangement.Start
                        ) {
                            blogEnum.linkTags.forEach { [text, url] ->
                                Box(
                                    modifier = Modifier
                                        .margin(right = 8.px, bottom = 8.px)
                                        .backgroundColor(
                                            Color.rgba(
                                                245,
                                                158,
                                                11,
                                                0.05f
                                            )
                                        )
                                        .padding(leftRight = 10.px, bottom = 5.px)
                                        .borderRadius(6.px)
                                        .border(
                                            1.px,
                                            LineStyle.Solid,
                                            Color.rgba(245, 158, 11, 0.15f)
                                        ),
                                ) {
                                    Link(
                                        path = url,
                                        //openExternalLinksStrategy = OpenLinkStrategy.IN_NEW_TAB,
                                        modifier = Modifier.fillMaxWidth()
                                            .styleModifier {
                                                property("text-decoration", "none")
                                                property("transition", "all 0.3s ease")
                                            }
                                    ) {
                                        Span(
                                            attrs = Modifier
                                                .fontFamily(Constants.FONT_FAMILY)
                                                .fontSize(10.px)
                                                .fontWeight(FontWeight.Bold)
                                                .color(AMBER_500)
                                                .toAttrs(),
                                        ) {
                                            Text(text)

                                            AppearanceAwareImage(
                                                src = Resources.Images.NAVIGATION_ARROW
                                            )
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}


@Composable
private fun ImmutableMap<String, List<Blog>>.BlogItem() {
    this@BlogItem.ExperienceCardV2()
}

@Composable
private fun ImmutableMap<String, List<Blog>>.ExperienceCardV2() {
    values.flatten().distinctBy { it.blogEnum }.forEachIndexed { index, blog ->
        (val links, val blogEnum = blogEnum) = blog
        val rowDelay = "${(index * 0.04).coerceAtMost(0.4)}s"

        links.forEach { [text, url] ->
            Link(
                path = url,
                modifier = Modifier.fillMaxWidth().margin(topBottom = 10.px)
                    .styleModifier {
                        property("text-decoration", "none")
                        property("transition", "all 0.3s ease")
                        property("animation", "adminRowIn 0.3s ease $rowDelay both")
                    }
            ) {
                Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .backgroundColor(DARK_CARD_BG)
                        .borderRadius(20.px)
                        .border(1.px, LineStyle.Solid, CARD_BORDER)
                        .styleModifier {
                            property("box-shadow", "0 10px 40px rgba(0,0,0,0.2)")
                            property("position", "relative")
                        }
                ) {
                    Box(
                        modifier = Modifier
                            .position(Position.Absolute)
                            .top(0.px)
                            .right(0.px)
                            .backgroundColor(AMBER_500)
                            .padding(leftRight = 14.px, topBottom = 6.px)
                            .borderRadius(bottomLeft = 12.px, topRight = 20.px),
                    ) {
                        Span(
                            attrs = Modifier
                                .fontFamily(Constants.FONT_FAMILY)
                                .fontSize(11.px)
                                .color(Colors.White)
                                .styleModifier {
                                    property("letter-spacing", "1px")
                                    property("text-transform", "uppercase")
                                }
                                .toAttrs()
                        ) {
                            Text(blogEnum.fromTo)
                        }
                    }

                    Column(modifier = Modifier.padding(all = 32.px)) {
                        // Blog Title
                        H3(
                            attrs = Modifier
                                .fontFamily(Constants.FONT_FAMILY)
                                .fontWeight(FontWeight.Black)
                                .color(Colors.White)
                                .margin(topBottom = 0.px)
                                .toAttrs()
                        ) {
                            Text(text)
                        }

                        Row(
                            modifier = Modifier
                                .margin(top = 16.px, bottom = 24.px)
                                .backgroundColor(Color.rgba(255, 255, 255, 0.03f))
                                .padding(leftRight = 14.px, topBottom = 8.px)
                                .borderRadius(8.px),
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            Span(
                                attrs = Modifier
                                    .fontFamily(Constants.FONT_FAMILY)
                                    .fontSize(16.px)
                                    .color(Color.rgba(255, 255, 255, 0.7f))
                                    .toAttrs()
                            ) {
                                Text(blogEnum.description)
                            }
                        }

                        // Bullet Points
                        if (blogEnum.bulletPoints.isNotEmpty()) {
                            Column(modifier = Modifier.margin(bottom = 32.px)) {
                                blogEnum.bulletPoints.forEach { point ->
                                    Row(modifier = Modifier.margin(bottom = 12.px)) {
                                        Box(
                                            modifier = Modifier
                                                .size(6.px)
                                                .backgroundColor(AMBER_500)
                                                .margin(top = 8.px, right = 14.px)
                                                .borderRadius(50.percent),
                                        )
                                        P(
                                            attrs = Modifier
                                                .margin(topBottom = 0.px)
                                                .fontFamily(Constants.FONT_FAMILY)
                                                .fontSize(14.px)
                                                .color(Color.rgba(255, 255, 255, 0.5f))
                                                .lineHeight(1.6)
                                                .toAttrs(),
                                        ) {
                                            Text(point.replace("▪ ", "").trim())
                                        }
                                    }
                                }
                            }
                        }

                        if (blogEnum.tags.isNotEmpty()) {
                            Row(
                                modifier = Modifier.fillMaxWidth()
                                    .styleModifier { property("flex-wrap", "wrap") },
                                horizontalArrangement = Arrangement.Start
                            ) {
                                blogEnum.tags.forEach { tag ->
                                    Box(
                                        modifier = Modifier
                                            .margin(right = 8.px, bottom = 8.px)
                                            .backgroundColor(
                                                Color.rgba(
                                                    245,
                                                    158,
                                                    11,
                                                    0.05f
                                                )
                                            )
                                            .padding(leftRight = 10.px, topBottom = 5.px)
                                            .borderRadius(6.px)
                                            .border(
                                                1.px,
                                                LineStyle.Solid,
                                                Color.rgba(245, 158, 11, 0.15f)
                                            )
                                    ) {
                                        Span(
                                            attrs = Modifier
                                                .fontFamily(Constants.FONT_FAMILY)
                                                .fontSize(10.px)
                                                .fontWeight(FontWeight.Bold)
                                                .color(AMBER_500)
                                                .toAttrs()
                                        ) {
                                            Text(tag)
                                        }
                                    }
                                }
                            }
                        }

                        if (blogEnum.linkTags.isNotEmpty()) {
                            Row(
                                modifier = Modifier.fillMaxWidth()
                                    .styleModifier { property("flex-wrap", "wrap") },
                                horizontalArrangement = Arrangement.Start
                            ) {
                                blogEnum.linkTags.forEach { [text, url] ->
                                    Box(
                                        modifier = Modifier
                                            .margin(right = 8.px, bottom = 8.px)
                                            .backgroundColor(
                                                Color.rgba(
                                                    245,
                                                    158,
                                                    11,
                                                    0.05f
                                                )
                                            )
                                            .padding(leftRight = 10.px, bottom = 5.px)
                                            .borderRadius(6.px)
                                            .border(
                                                1.px,
                                                LineStyle.Solid,
                                                Color.rgba(245, 158, 11, 0.15f)
                                            ),
                                    ) {
                                        Link(
                                            path = url,
                                            modifier = Modifier.fillMaxWidth()
                                                .styleModifier {
                                                    property("text-decoration", "none")
                                                    property("transition", "all 0.3s ease")
                                                }
                                        ) {
                                            Span(
                                                attrs = Modifier
                                                    .fontFamily(Constants.FONT_FAMILY)
                                                    .fontSize(10.px)
                                                    .fontWeight(FontWeight.Bold)
                                                    .color(AMBER_500)
                                                    .toAttrs(),
                                            ) {
                                                Text(text)

                                                AppearanceAwareImage(
                                                    src = Resources.Images.NAVIGATION_ARROW
                                                )
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}


val GlintAnim = Keyframes {
    0.percent { Modifier.styleModifier { property("background-position", "-200% center") } }
    100.percent { Modifier.styleModifier { property("background-position", "200% center") } }
}


@OptIn(ExperimentalComposeWebApi::class)
@Composable
fun SearchBar(
    modifier: Modifier,
    scope: CoroutineScope,
    isSearchExpanded: Boolean,
    searchText: String,
    onSearchTextChange: (query: String) -> Unit,
    onSearchExpanded: () -> Unit
) {
    Row(
        modifier = modifier
            .width(if (isSearchExpanded) 240.px else 40.px)
            .height(35.px)
            .margin(right = 24.px)
            .border {
                width(1.px)
                style(LineStyle.Solid)
                color(AMBER_500)
            }
            .backgroundColor(Color.rgba(255, 255, 255, 0.05f))
            .borderRadius(4.px)
            .transition(
                Transition.all(
                    300.ms,
                    TransitionTimingFunction.EaseInOut
                )
            ),
        horizontalArrangement = Arrangement.End,
        verticalAlignment = Alignment.CenterVertically
    ) {
        if (isSearchExpanded) {
            TextInput(
                text = searchText,
                onTextChange = { onSearchTextChange(it) },
                focusBorderColor = Colors.Transparent,
                modifier = InputStyle
                    .toModifier()
                    .styleModifier {
                        property("color", "white")
                        property("font-size", "14px")
                    }
                    .fillMaxWidth(85.percent)
                    .height(100.percent)
                    .border(0.px)
                    .padding(leftRight = 12.px)
                    .outline(0.px)
                    .attrsModifier {
                        attr("placeholder", "Search")
                    }
            )
        }

        Box(
            modifier = modifier
                .width(40.px)
                .height(40.px)
                .cursor(Cursor.Pointer)
                .padding(8.px)
                .onClick {
                    scope.launch {
                        if (isSearchExpanded && searchText.isNotEmpty()) {
                        } else {
                            onSearchExpanded()

                            if (isSearchExpanded) {
                                delay(100.milliseconds)
                            } else {
                                onSearchTextChange("")
                            }
                        }
                    }
                },
            contentAlignment = Alignment.Center
        ) {
            Image(
                src = SEARCH_LIGHT,
                modifier = modifier
                    .width(20.px)
                    .height(20.px)
            )
        }
    }
}

